import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {getText, renderMarkdown} from 'helpers/text-helper';
import {themesData} from 'data/themes-data';
import GameProgress from 'components/ui/game-progress/game-progress';
import YouTube from 'react-youtube';
import Button from 'components/ui/button/button';
import './game-intro.scss';

const GameIntro = ({languageId, deviceInfo, gameData, goToPage}) => {

	const themeId = (gameData.themeId ? gameData.themeId : 'theme-1-1');
	const themeData = themesData.find((t) => {
		return t.id === themeId;
	});
	
	const videoId = themeData.introVideoId[languageId];

	
	/* Video state and ref */
	const [videoState, setVideoState] = useState('loading');
	const [videoRef, setVideoRef] = useState(null);

	/**
	 * Start video
	 * @param {object} e 
	 * @returns 
	 */
	const handlePlay = (e) => {
		e.stopPropagation();
		if (videoState === 'loading') return;
		if (videoRef && videoRef.playVideo) {
			setVideoState('buffering');
			videoRef.playVideo();
		}
	};

	const handleEnd = () => {
		setVideoState('ended');
		if (document.fullscreenElement) {
			setTimeout(() => {return document.exitFullscreen();}, 100);
		}
		
	};

	return (
		<div className={'GameIntro ' + deviceInfo.orientation}>
			{/* Home btn */}
			<div className="GameIntro-homeBtn" onClick={() => {goToPage('settings');}} />


			{/* Content */}
			<div className='GameIntro-content'>
				<GameProgress 
					languageId={languageId}
					progressStepId={'intro'}
					deviceInfo={deviceInfo}
				/>
				
				<div className='GameIntro-title'>
					<span>{getText('pages_introTitle', languageId)}</span>
				</div>
			
				<div className='GameIntro-text'>
					{renderMarkdown(getText(themeData.intro, languageId))}
				</div>

				{videoId && <div className="GameIntro-videoWrap">
					<YouTube 
						className={'GameIntro-video ' + videoState} 
						videoId={videoId} 
						onReady={(e) => {setVideoRef(e.target); setVideoState('ready');}}
						onPlay={() => {setVideoState('playing');}}
						onPause={() => {setVideoState('paused');}}
						onEnd={() => {handleEnd();}}
						opts={{
							height: '100%', 
							width: '100%', 
							playerVars: {
								controls: 1,
							}
						}}
					/>
					<div 
						className={'GameIntro-videoPlayBtn ' + videoState} 
						onClick={(e) => {handlePlay(e);}} 
					/>
				</div>}

			</div>


			{/* Next btn */}
			<div className='GameIntro-nextBtn'>
				<Button
					text={getText('general_next', languageId)}
					classes={['orange', 'next', 'fullHeight']}
					onClick={() => {goToPage('game-groups');}}
				/>
			</div>

		</div>
	);
};

GameIntro.propTypes = {
	languageId: PropTypes.string.isRequired,
	deviceInfo: PropTypes.object.isRequired,
	gameData: PropTypes.object.isRequired,
	goToPage: PropTypes.func.isRequired
};

export default GameIntro;